module.exports = __webpack_public_path__ + "static/media/search.7d994676.png";